import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  UserCircle,
  Footprints,
  Camera,
  Activity,
  BarChart3,
  FileBarChart2,
  UserCog,
  X,
  Bot
} from "lucide-react";

const menus = [
  { to: "/customer-flow", label: "แดชบอร์ด", icon: LayoutDashboard },
  { to: "/visit-log", label: "คนเดินเข้าร้าน", icon: Footprints },
  { to: "/pass-by-dashboard", label: "คนเดินผ่านร้าน", icon: Activity },
  { to: "/customer-insight", label: "ข้อมูลลูกค้าเชิงลึก", icon: BarChart3 },
  { to: "/member", label: "ลูกค้าสมาชิก", icon: Users },
  { to: "/staff-dashboard", label: "ข้อมูลพนักงาน", icon: UserCircle },
  { to: "/branch-performance-report", label: "รายงานประสิทธิภาพสาขา", icon: FileBarChart2 },
  { to: "/mini-ai", label: "Mini AI", icon: Bot, aiOnly: true },

  // MAIN ONLY
  {
    to: "/devices-setting",
    label: "ตั้งค่าอุปกรณ์",
    icon: Camera,
    mainOnly: true
  },
  {
    to: "/user-setting",
    label: "ตั้งค่าผู้ใช้งาน",
    icon: UserCog,
    mainOnly: true
  }
];

export default function Sidebar({ open, onClose }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isMain = user?.is_main || false;
  const [aiEnabled, setAIEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    fetch("/api/ai/status", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then(response => response.ok ? response.json() : null)
      .then(result => active && setAIEnabled(Boolean(result?.enabled)))
      .catch(() => active && setAIEnabled(false));
    return () => { active = false; };
  }, []);

  return (
    <>
      {/* Overlay (mobile) */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed md:static inset-y-0 left-0 z-50
          w-64 bg-white border-r
          px-4 py-6
          transform transition-transform
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        {/* Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-lg font-bold tracking-tight">PIXELS AI DATA BUSINESS</h1>
            <p className="text-xs text-gray-400">Dashboard</p>
          </div>

          {/* Close (mobile) */}
          <button
            onClick={onClose}
            className="md:hidden p-1 rounded hover:bg-gray-100"
          >
            <X size={18} />
          </button>
        </div>

        {/* Menu */}
        <nav className="space-y-1">
          {menus
            .filter(menu => {
              if (menu.mainOnly && !isMain) {
                return false;
              }
              if (menu.aiOnly && !aiEnabled) {
                return false;
              }

              return true;
            })
            .map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition
                ${
                  isActive
                    ? "bg-teal-50 font-semibold text-[#008f90] ring-1 ring-teal-100"
                    : "text-gray-600 hover:bg-gray-50"
                }`
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

      </aside>
    </>
  );
}
